


export const EMOJI_SUCCESS_HAND = '1f44d;';
export const EMOJI_MONKEY = '1f648;';
export const EMOJI_GHOST = '1f47b;';
export const EMOJI_PRINT = '1F4C7;';
export const EMOJI_WATCH_SAND = '231B;';
